import {Component, OnInit} from "@angular/core";
import {IntegrationTypeStepBaseComponent} from "../integration-type-step-base.component";
import {NavigationItem} from "../../../../../../../core/shared/dto/navigation/navigation-item";

/**
 * IntegrationTypeStepSideComponent
 *
 * Side panel view for hc.IntegrationTypeStep entity.
 * Provides navigation to child entity sections:
 * - stepInfo: Schritt-Info (step details widget)
 * - stepInputs: Schritt-Eingaben (IntegrationTypeStepInput table)
 * - stepOutputs: Schritt-Ausgaben (IntegrationTypeStepOutput table)
 * - stepTransitions: Schritt-Übergänge (IntegrationTypeStepTransition tables)
 */
@Component({
    selector: 'hc-integration-type-step-side-component',
    templateUrl: 'integration-type-step-side.component.html',
    standalone: false
})
export class IntegrationTypeStepSideComponent extends IntegrationTypeStepBaseComponent implements OnInit {

    navigationItems: NavigationItem[] = [
        {
            label: 'stepInfo',
            action: 'stepInfo',
            tooltip: 'Schritt-Info',
            icon: 'fa-regular fa-circle-info',
            toggleable: false,
            default: true
        },
        {
            label: 'stepInputs',
            action: 'stepInputs',
            tooltip: 'Schritt-Eingaben',
            icon: 'fa-regular fa-arrow-right-to-bracket',
            toggleable: false,
            default: false
        },
        {
            label: 'stepOutputs',
            action: 'stepOutputs',
            tooltip: 'Schritt-Ausgaben',
            icon: 'fa-regular fa-arrow-right-from-bracket',
            toggleable: false,
            default: false
        },
        {
            label: 'stepTransitions',
            action: 'stepTransitions',
            tooltip: 'Schritt-Übergänge',
            icon: 'fa-regular fa-arrows-left-right',
            toggleable: false,
            default: false
        },
    ];

    ngOnInit() {
        super.ngOnInit();
    }
}
